import { Box, Menu } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventStatus, Role } from '../../services/Types'
import VerticleEllipsisIcon from '../../images/verticleEllipsisIcon.svg'
import { SendANotification } from '../SendANotification/SendANotification'
import { EventDetailsPopup } from '../EtaCalendar/EventDetailsPopup'
import { StyledMenuItem } from './ActionMenus.styles'
import { useEvent } from '../../hooks/useEvent'
import { DialogCancelEvent } from '../Dialogs/Cancel'
import { DialogRejectEvent } from '../Dialogs/Reject'

export const ActionMenus = ({
  data,
  onCancelEvent,
  onRevertEvent,
}: {
  data: any
  onCancelEvent: (id: number) => void
  onRevertEvent: (id: number) => void
}) => {
  const { id, seriesId, status, ownEvent } = data
  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openDialog, setOpenDialog] = useState('')
  const [requestType, setRequestType] = useState('Select')

  const {
    handleSendNotification,
    logMessage,
    setLogMessage,
  } = useEvent();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const [showCancelDialog, setShowCancelDialog] = useState(false)
  const [showRejectDialog, setShowRejectDialog] = useState(false)

  const sendANotification = async () => {
    const success = await handleSendNotification(id, requestType);
    if (success) {
      setOpenDialog('');
    }
  }

  let user: any = localStorage.getItem('user')
  if (user) user = JSON.parse(user)
  const [openEventDetails, setOpenEventDetails] = useState(false)

  return (
    <div>
      <Box>
        <Box
          component='img'
          src={VerticleEllipsisIcon}
          alt='VerticleEllipsisIcon'
          onClick={handleClick}
          sx={{ cursor: 'pointer', pl: '7.5px' }}
        />
      </Box>
      <Menu
        id='demo-positioned-menu'
        aria-labelledby='demo-positioned-button'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        PaperProps={{
          style: {
            width: 150
          }
        }}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {user?.role === Role.APPROVER && !ownEvent && [
          <StyledMenuItem key="approve" onClick={() => {
            if (status !== EventStatus.APPROVED) {
              window.open(`/event/review/${id}`, '_blank')
              handleClose()
            }
          }}>
            Approve
          </StyledMenuItem>,

          <StyledMenuItem key="decline" onClick={() => {
            if (status !== EventStatus.SAVED) {
              setShowRejectDialog(true)
              handleClose()
            }
          }}>
            Decline
          </StyledMenuItem>
        ]}
        {user !== null && (
          <StyledMenuItem key="view-edit" onClick={() => {
            window.open(`/event/review/${id}`, '_blank')
            handleClose()
          }}>
            View/Edit
          </StyledMenuItem>
        )}

        {user !== null && (user?.role === Role.REQUESTER || (user?.role === Role.APPROVER && ownEvent) || user?.role === Role.ADMIN) && (
          <StyledMenuItem
            key="cancel-event"
            disabled={status !== EventStatus.APPROVED}
            onClick={() => {
              setShowCancelDialog(true)
              handleClose()
          }}>
            Cancel Event
          </StyledMenuItem>
        )}
        {user !== null && user?.role !== Role.REQUESTER && user?.role !== Role.ADMIN && !ownEvent && (
          <StyledMenuItem key="revision-request" onClick={() => {
            setOpenDialog('Send Message')
            handleClose()
          }}>
            Revision Request
          </StyledMenuItem>
        )}
      </Menu>

      <SendANotification
        open={openDialog === 'Send Message'}
        onClose={() => setOpenDialog('')}
        onPrimaryButtonClick={sendANotification}
        onSecondaryButtonClick={() => setOpenDialog('')}
        requestType={requestType}
        setRequestType={setRequestType}
        logMessage={logMessage}
        setLogMessage={setLogMessage}
      />
      {openEventDetails && (
        <EventDetailsPopup
          id={id}
          open={openEventDetails}
          setOpen={setOpenEventDetails}
        />
      )}
      {showCancelDialog && (
        <DialogCancelEvent
          eventId={id}
          onSuccess={() => {
            onCancelEvent(id);
            setShowCancelDialog(false);
          }}
          onCancel={() => setShowCancelDialog(false)}
        />
      )}

      {showRejectDialog && (
        <DialogRejectEvent
          eventId={id}
          onSuccess={() => {
            onRevertEvent(id);
            setShowRejectDialog(false);
          }}
          onCancel={() => setShowRejectDialog(false)}
        />
      )}
    </div>
  )
}
